import { graphql } from '@prophecy/graphql-types/graphql';

import { makeGraphQlCallWithoutShareTokens } from '../../data/util';

const GuestUserQuery = graphql(`
  query GuestUserQuery($uid: String!) {
    User(uid: $uid) {
      firstName
      lastName
      email
      _id
    }
  }
`);

export const getGuestUserData = async (guestUserId: string, _enabled?: boolean) => {
  const resp = await makeGraphQlCallWithoutShareTokens(GuestUserQuery, { uid: guestUserId as string });
  return resp?.User ?? {};
};
